import React, { useState, useEffect } from "react";
import $ from "jquery";
import "jstree";
import "jstree/dist/themes/default/style.css";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import AgentTree from "../components/AgentTree";
import DateTimeRangePicker from "../components/DateTimeRangePicker";
import {
  getInitialDateTimeRange,
  getPresetDateTimeRange,
} from "../utils/dateRange";
dayjs.extend(utc);
dayjs.extend(timezone);
window.$ = window.jQuery = $;

export default function ReportPartner() {
  const navigate = useNavigate();
  const initialRange = getInitialDateTimeRange();
  const [users, setUser] = useState(null);
  const [user_list, setUser_list] = useState(null);
  const [report, setReport] = useState(null);
  const [prefixData, setPrefixData] = useState(null);
  const [startDateTime, setStartDateTime] = useState(initialRange.start);
  const [endDateTime, setEndDateTime] = useState(initialRange.end);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { setIsLoggedIn } = useOutletContext();



  const handleDateRange = (type) => {
    const range = getPresetDateTimeRange(type);
    setStartDateTime(range.start);
    setEndDateTime(range.end);
  };

  const fetchReportData = async (prefixParam) => {
    const params = {
      prefix: prefixParam ?? prefixData,
      reg_dt_start: startDateTime.replace("T", " ") + ":00",
      reg_dt_end: endDateTime.replace("T", " ") + ":59",
    };
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/ReportPatner`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReport(res.data.rows);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("유저 정보 불러오기 실패:", err);
    }
  };
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE}/api/Users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(res.data);
        const prefix = res.data.Prefix;
        setPrefixData(prefix);
        fetchReportData(prefix);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false); // 로그인 상태 false 처리
            navigate("/login"); // 로그인 화면으로 리다이렉트
            return;
          }
        }
        console.error("유저 정보 불러오기 실패:", err);
      }
    };

    fetchUserInfo();
  }, []);

  const handleAgentClick = (prefix) => {
  setPrefixData(prefix);
  fetchReportData(prefix);
};

  //호출시 날짜 받아서 전송
  //첫호출후 jtree에서 클릭되면 user_list에 있는 userId에서 프리픽스 뽑아서 전송
  //type에따라서 테이블 동적생성
  if (!users) return <div>로딩 중...</div>;
  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block d-flex vReport">
              <div className="d-none d-xl-block w-30 me-1 mt-1 w-min-300px">
                <div className="dropdown partnerTree">
                  <div className="dropdown-menu p-3 ps-1 d-block">
                    {users && (
                      <AgentTree user={users} onAgentClick={handleAgentClick} />
                    )}
                  </div>
                </div>
              </div>
              <div className="w-100 card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3 p-0">
                    <div className="nk-block nk-block-lg">
                      <form
                        className="mb-0"
                        onSubmit={(e) => {
                          e.preventDefault();
                          fetchReportData(prefixData);
                        }}
                      >
                        <DateTimeRangePicker
                          startDateTime={startDateTime}
                          endDateTime={endDateTime}
                          onStartChange={setStartDateTime}
                          onEndChange={setEndDateTime}
                          onPresetChange={handleDateRange}
                        >
                          <div className="col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2 d-flex align-items-end">
                            <button
                              type="submit"
                              className="btn btn-outline-primary btn-dim w-100"
                            >
                              <em className="icon ni ni-search me-1" />
                              검색
                            </button>
                          </div>
                        </DateTimeRangePicker>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="nk-files-group user-days">
                  <div className="nk-files-group user-days">
                    <div
                      className="table-wrapper"
                      style={{
                        borderTop: "1px dotted #BBB",
                        paddingTop: "5px 0",
                      }}
                    >
                      <div className="btn-toolbar justify-content-between"></div>
                      <div
                        className="table-responsive"
                        data-fixed-nav-bar="true"
                        data-pattern="priority-columns"
                      >
                        <table
                          cellSpacing="0"
                          className="table table-small-font table-tighten table-bordered table-striped navbar-fixed-top"
                        >
                          <thead>
                            <tr data-pos-y="0">
                              <th
                                data-pos-x="0"
                                data-priority="1"
                                id="id7f622c316d45c-col-0"
                              >
                                <span className="sub-text text-center">
                                  일별
                                </span>
                              </th>
                              <th
                                data-pos-x="1"
                                data-priority="1"
                                id="id7f622c316d45c-col-1"
                              >
                                <span className="sub-text text-center">
                                  화폐
                                </span>
                              </th>
                              <th
                                data-pos-x="2"
                                data-priority="1"
                                id="id7f622c316d45c-col-2"
                              >
                                <span className="sub-text text-center">
                                  관리자 지급
                                </span>
                              </th>
                              <th
                                data-pos-x="3"
                                data-priority="1"
                                id="id7f622c316d45c-col-3"
                              >
                                <span className="sub-text text-center">
                                  관리자 회수
                                </span>
                              </th>
                              <th
                                data-pos-x="4"
                                data-priority="1"
                                id="id7f622c316d45c-col-4"
                              >
                                <span className="sub-text text-center">
                                  상부가 지급
                                </span>
                              </th>
                              <th
                                data-pos-x="5"
                                data-priority="1"
                                id="id7f622c316d45c-col-5"
                              >
                                <span className="sub-text text-center">
                                  상부가 회수
                                </span>
                              </th>
                              <th
                                data-pos-x="6"
                                data-priority="1"
                                id="id7f622c316d45c-col-6"
                              >
                                <span className="sub-text text-center">
                                  하부에 지급
                                </span>
                              </th>
                              <th
                                data-pos-x="7"
                                data-priority="1"
                                id="id7f622c316d45c-col-7"
                              >
                                <span className="sub-text text-center">
                                  하부를 회수
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                           {report && report.length > 0 ? (
  (() => {
    const sums = [0, 0, 0, 0, 0, 0];

    report.forEach((item) => {
      if (item.type >= 0 && item.type < 6) {
        sums[item.type] += Math.abs(item.cash);
      }
    });

    const baseDate = dayjs(report[0].reg_dt).format("YYYY-MM-DD");

    return (
      <tr data-pos-y="0">
        <td
          className="text-center"
          data-columns="id7f622c316d45c-col-0"
          data-pos-x="0"
          data-priority="1"
        >
          <a href="#">{baseDate}</a>
        </td>
        <td
          className="text-center"
          data-columns="id7f622c316d45c-col-1"
          data-pos-x="1"
          data-priority="1"
        >
          KRW
        </td>

        {[0, 1, 2, 3, 4, 5].map((i) => (
          <td
            key={`sum-col-${i}`}
            className="text-end"
            data-columns={`id7f622c316d45c-col-${i + 2}`}
            data-pos-x={i + 2}
            data-priority="1"
          >
            <span>{sums[i].toLocaleString()}</span>
          </td>
        ))}
      </tr>
    );
  })()
) : (
  <tr>
    <td colSpan={8} className="text-center text-muted">
      🔍 조회된 데이터가 없습니다.
    </td>
  </tr>
)}
                          </tbody>
                          <tfoot className="dt_user_view_total">
  {report && report.length > 0 && (() => {
    const totalSums = [0, 0, 0, 0, 0, 0];

    report.forEach((item) => {
      if (item.type >= 0 && item.type < 6) {
        totalSums[item.type] += Math.abs(item.cash);
      }
    });

    return (
      <tr data-pos-y="0">
        <td className="text-center" data-columns="id7f622c316d45c-col-0" data-pos-x="0" data-priority="1">
          합계
        </td>
        <td className="text-center" data-columns="id7f622c316d45c-col-1" data-pos-x="1" data-priority="1">
          KRW
        </td>

        {[0, 1, 2, 3, 4, 5].map((i) => (
          <td
            key={`total-col-${i}`}
            className="text-end"
            data-columns={`id7f622c316d45c-col-${i + 2}`}
            data-pos-x={i + 2}
            data-priority="1"
          >
            <span>{totalSums[i].toLocaleString()}</span>
          </td>
        ))}
      </tr>
    );
  })()}
</tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
